import { useEffect, useState } from "react";
import { Sidebar, type RouteId } from "./components/Sidebar";
import { HomePage } from "./pages/HomePage";
import { AnalyticsPage } from "./pages/AnalyticsPage";
import { BugReportsPage } from "./pages/BugReportsPage";
import { ErrorsPage } from "./pages/ErrorsPage";
import { FeatureRequestsPage } from "./pages/FeatureRequestsPage";
import styles from "./App.module.css";

/**
 * Top-level admin shell — fixed sidebar on the left, scrollable
 * content on the right. Hash-based routing (no react-router dep);
 * total of four routes makes a switch cheaper than the dependency.
 */
export function App() {
  const [route, setRoute] = useState<RouteId>(readRouteFromHash());

  useEffect(() => {
    const onHash = () => setRoute(readRouteFromHash());
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);

  return (
    <div className={styles.shell}>
      <Sidebar current={route} />
      <main className={styles.main}>
        {route === "home" ? <HomePage /> : null}
        {route === "analytics" ? <AnalyticsPage /> : null}
        {route === "errors" ? <ErrorsPage /> : null}
        {route === "bug-reports" ? <BugReportsPage /> : null}
        {route === "feature-requests" ? <FeatureRequestsPage /> : null}
      </main>
    </div>
  );
}

function readRouteFromHash(): RouteId {
  const h = window.location.hash.replace(/^#\/?/, "");
  if (
    h === "analytics" ||
    h === "errors" ||
    h === "bug-reports" ||
    h === "feature-requests"
  ) {
    return h;
  }
  return "home";
}
